module.exports = __webpack_public_path__ + "img/bg_both.ff021d4e.svg";